import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@wilson/interfaces';
import { addressFormat } from './address-format.fn';

@Pipe({
  name: 'addressFormat',
  standalone: false,
})
export class AddressPipe implements PipeTransform {
  transform(
    address: Pick<Address, 'street' | 'postCode' | 'city' | 'country'>,
  ): string {
    return addressFormat(address);
  }
}
